import { isProspectStage } from "src/Modules/Company/Enums/ClientStatus.enum";

const GUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export interface IOpenClientContext {
  companyRowID: string;
  clientStatusID: number | null;
}

/**
 * Returns the `link` of the tab that should be highlighted for the current URL.
 * Client-scoped routes follow the open client's status: Prospect/Onboarding light
 * PROSPECTS, everything else (including no-status and unknown statuses) lights HOME.
 * Computed from the current location and loaded client, never navigation history,
 * so deep links resolve correctly on load.
 */
export const getActiveTabLink = (
  pathname: string,
  openClient?: IOpenClientContext | null,
): string => {
  if (pathname === "/company" || pathname === "/company/") return "company";
  if (pathname.startsWith("/assigned-actions")) return "assigned-actions";
  if (pathname.startsWith("/company/sla-reporting"))
    return "company/sla-reporting";
  if (pathname.startsWith("/company/prospects")) return "company/prospects";
  // Add New Client is part of the prospects pipeline.
  if (pathname.startsWith("/company/add")) return "company/prospects";
  if (pathname.startsWith("/company/archived")) return "company";

  const clientSegment = pathname.split("/")[2];
  if (clientSegment && GUID_REGEX.test(clientSegment)) {
    const isOpenClientRoute =
      openClient &&
      openClient.companyRowID &&
      openClient.companyRowID.toLowerCase() === clientSegment.toLowerCase();
    return isOpenClientRoute && isProspectStage(openClient.clientStatusID)
      ? "company/prospects"
      : "company";
  }

  if (pathname.startsWith("/company")) return "company";
  return "";
};
